import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">常见问题</h2>
        <div className="space-y-3">
          {faqItems.map((item) => (
            <details key={item.id} className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between px-5 py-4 text-foreground-800 font-medium text-sm md:text-base list-none">
                <span>{item.question}</span>
                <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}